import { Location } from '@angular/common';
import { Component, OnInit , ElementRef, ViewChild} from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { NgForm } from '@angular/forms';
import { ApiService } from './../../service/api.service';
import { Settings } from './../../service/settings/settings';
import * as $ from "jquery";
import * as CryptoJS from 'crypto-js';
import { Storage } from '@ionic/storage';
import { AlertController, NavController } from '@ionic/angular';
import { JoyrideOptions } from 'ngx-joyride/lib/models/joyride-options.class';
import { JoyrideService } from 'ngx-joyride';
import { v4 as uuidv4 } from 'uuid'; // <-- Import UUID generator

@Component({
  selector: 'app-newlogin',
  templateUrl: './newlogin.component.html',
  styleUrls: ['./newlogin.component.scss'],
})
export class NewloginComponent implements OnInit {

  @ViewChild('endtour', { read: ElementRef})  btn: ElementRef;

  isLoading = false;
  result: any;
  isLoggedIn: boolean;
  public userloggedin: boolean = false;
  isadd: Boolean = false;
  counter = 10;

  constructor(private location: Location, private storage: Storage, public api: ApiService,
    private _Router: Router, public settings: Settings,
    private navCtrl: NavController
    , public altertCtl: AlertController,
    private alertController: AlertController,
    private readonly joyrideService: JoyrideService
  ) {


  }

  ngOnInit() {
    this.storage.get('sellerclient').then((val) => {
      var objtemp = $.parseJSON(val);
      if (typeof (objtemp) !== 'undefined' && objtemp !== null) {
        this.navCtrl.navigateRoot('/analytical/all');
      }
    });
  }

  passwordType: string = 'password';
  passwordIcon: string = 'eye-off';

  hideShowPassword() {
    this.passwordType = this.passwordType === 'text' ? 'password' : 'text';
    this.passwordIcon = this.passwordIcon === 'eye-off' ? 'eye' : 'eye-off';
  }


  //this.presentAlert
  starttour() {
    const options: JoyrideOptions = {
      steps: ['step1', 'step2', 'step3','step4'],
      themeColor: '#000000',
      showCounter: false
    };
    this.joyrideService.startTour(options);
  }

  scrolltoView()
  {
    this.btn.nativeElement.scrollIntoView({behaviour: 'auto', block: 'start'});
  }


  async presentAlert(strheader: string, strmessage: string) {
    const alert = await this.altertCtl.create({
      header: strheader,
      message: strmessage,
      buttons: [
        {
          text: 'Ok',
          role: 'cancel',
          cssClass: 'secondary',
          handler: (blah) => {
          }
        }
      ]
    });
    await alert.present();
  }

onSubmit(form: NgForm) {
    if (!form.valid) { return; }

    const email = form.value.email;
    const user_pass = form.value.user_pass;

    // 1. Get or Generate unique browser ID
    let deviceId = localStorage.getItem('family_device_uuid');
    if (!deviceId) {
      deviceId = uuidv4(); 
      localStorage.setItem('family_device_uuid', deviceId);
    }

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
    const deviceType = isMobile ? 'Mobile Browser' : 'Laptop Browser';

    // 2. Call the Python Flask API 
    // ** Ensure you replace 'YOUR_PYTHON_IP' with your actual VPS IP / Domain **
    this.api.postData('api/login', { 
      email: email, 
      password: user_pass,
      device_uuid: deviceId,
      device_name: deviceType
    }).subscribe(
      (response: any) => {
        if (response && response.token) {
           // Success!
           this.storage.set('auth_token', response.token);
           
           // Keep your existing local storage setup for compatibility with the rest of your app
           let user: { user_id: string } = { user_id: 'admin' };
           this.storage.set('sellerclient', JSON.stringify(user));
           
           this.navCtrl.navigateRoot('/analytical/all');
        } else {
           this.presentAlert('Authentication', response.message || 'Invalid Credentials');
        }
      },
      (error) => {
        // Triggers if limit is reached (403) or bad password (401)
        this.presentAlert('Login Error', error.error?.message || 'Login failed.');
      }
    );
  }


  bin2hex(bin) {
    var i = 0, l = bin.length, chr, hex = ''
    for (i; i < l; ++i) {
      chr = bin.charCodeAt(i).toString(16)
      hex += chr.length < 2 ? '0' + chr : chr
    }
    return hex
  }

  backClick() {
    this.location.back();
  }

}
